import { render } from "./HelpCenter.vue?vue&type=template&id=ac68bc46&scoped=true&ts=true"
import script from "./HelpCenter.vue?vue&type=script&lang=ts"
export * from "./HelpCenter.vue?vue&type=script&lang=ts"

import "./HelpCenter.vue?vue&type=style&index=0&id=ac68bc46&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac68bc46"]])

export default __exports__